import React from "react";
import { Column } from "devextreme-react/data-grid";
import DxfGrid from "shared/component/dxf-grid/dxf-grid";
import Back from "shared/assets/images/svg/back_blue.svg";

import { myBankAccountSource } from "./bank-account.service";
import { Link } from "react-router-dom";

const BankAccount = () => {
  
  return (
    <div className="myBooking">
      <div className="container">
      <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/">
              <img src={Back} alt="back" />
            </Link>
            <h1>Rwafi Bank Accounts</h1>
          </div>
       
        </div>

        <hr className="hr mb-0" />
        <div className="dataTable">
          <DxfGrid dataSource={myBankAccountSource}  >
            <Column dataField="enName" caption="Bank Name EN"  />
            <Column dataField="arname" caption="Bank Name AR"  />
            <Column dataField="num" caption="Acount Number" />
            <Column dataField="branch" caption="IBAN" />
            <Column dataField="currency" caption="Currency" />
          </DxfGrid>
        </div>

     
      </div>
    </div>
  );
};

export default BankAccount;
